import React, { useState, useEffect } from 'react'
import { toast, ToastContainer } from 'react-toastify'
import Header from '../header'
import Footer from '../NewFooter'
import { Grid, Typography, Button, Paper } from '@material-ui/core'
import { makeStyles } from '@material-ui/styles'
import { useHistory, useLocation } from 'react-router-dom'
import Select from 'react-select'
import request, { client, NodeURL, SubdomainURL } from '../../../api/api'
import './findJobs.css'
import icon7 from '../../../images/Jobs/icon_7.svg'
import icon8 from '../../../images/Jobs/icon_8.svg'
import icon9 from '../../../images/Jobs/icon_9.svg'
import Arrow_icon from '../../../images/Jobs/back_arrow.svg'
import { CheckValue } from '../../common/utils'

const useStyles = makeStyles(theme => ({
   // container: {
   //    maxWidth: 1140,
   //    marginLeft: 'auto',
   //    marginRight: 'auto',
   //    backgroundColor: '#fff',
   //    height: '2300px'
   // },
   title: {
      color: '#1A202C',
      fontWeight: 600,
      fontSize: '26px',
      lineHeight: '64px'
   },
   backBtnSpan: {
      paddingLeft: 10,
      cursor: 'pointer'
   },
   backicon: {
      cursor: 'pointer'
   },
   card: {
      display: 'flex',
      gap: 40,
      flexWrap: 'wrap'
   },
   cardAlignment: {
      display: 'flex',
      gap: 8
   },
   icon: {
      height: 15,
      width: 15,
      marginTop: 5
   },
   cardText: {
      color: '#1A202C'
   },
   salaryText: {
      marginTop: 10,
      color: '#1A202C',
      '& span': {
         color: '#5F4B95',
         fontSize: '22px',
         fontWeight: 600
      }
   },
   applyButton: {
      backgroundColor: '#1D9BF0',
      color: '#FFFFFF',
      marginTop: 10,
      width: 100,
      height: 35,
      padding: '0 60px',
      transition: 'color 0.3s ease',
      '&:hover': {
         color: '#1D9BF0',
         border: ' 1px solid #1d9bf0'
      }
   },

   jobDescriptionText: {
      marginTop: 10,
      color: 'black'
   },
   footerBtnDiv: {
      display: 'flex',
      justifyContent: 'end',
      gap: 14
   },
   backButton: {
      border: '1px solid #5F4B95',
      color: '#5F4B95',
      marginTop: 10,
      height: 35
   },
   companyLogo: {
      width: 40,
      height: 40,
      borderRadius: 50
   }
}))

const ViewBrowseJobs = () => {
   const classes = useStyles()
   const domHistory = useHistory()
   const domLocation = useLocation()

   const state = domLocation && domLocation.state && domLocation.state.searchFilters ? domLocation.state.searchFilters : null
   const data = domLocation && domLocation.state && domLocation.state.selectedJob ? domLocation.state.selectedJob : null

   const handleOnJobView = () => {
      const pushConfig = {
         pathname: '/jobs/browse',
         state: { selectedJob: data, searchFilters: state }
      }
      const hash = window.location.hash.substring(1)
      if (CheckValue(hash)) {
         pushConfig.hash = `#${hash}`
      }
      domHistory.push(pushConfig)
   }

   const handleOnJobsRedirect = data => {
      let subdomain = data && data.agencySubdomain ? data.agencySubdomain : data && data.agencySubdomain1 ? data.agencySubdomain1 : '';
      let query = {
         // job_type: data && Array.isArray(data.jobType) && data.jobType.length > 0 ? data.jobType.map(x => ({ label: x.name, value: x._id })) : [],
         job_type: data && Array.isArray(data.jobRole) && data.jobRole.length > 0 ? data.jobRole.map(x => ({ label: x.name, value: x._id })) : [],
         industryType:
            data && Array.isArray(data.industryType) && data.industryType.length > 0 ? data.industryType.map(x => ({ label: x.name, value: x._id })) : [],
         locations:
            data && Array.isArray(data.locationType) && data.locationType.length > 0 ? data.locationType.map(x => ({ label: x.name, value: x._id })) : [],
         agencyId: data && data.agencyId ? data.agencyId : ''
      }

      if (!subdomain) return
      const protocol = NodeURL.split(':')[0]
      let host = protocol === 'http' ? 'localhost:3007' : SubdomainURL
      let URL = `${protocol}://${subdomain}.${host}/candidate/register`

      // query is string if we dont use the array turn to [object, object] that why we use this method
      const queryString = Object.keys(query)
         .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(JSON.stringify(query[key]))}`)
         .join('&')

      if (queryString) {
         URL += `?${queryString}`
      }

      window.location.href = URL
   }

   return (
      <>
         <Header />
         <ToastContainer position="top-right" autoClose={2500} closeOnClick />
         <div className="container">
            <div className={classes.backBtn} onClick={handleOnJobView}>
               <img src={Arrow_icon} alt="icon" loading="lazy" className={classes.backicon} />
               <span className={classes.backBtnSpan}>Back</span>
            </div>
            <Typography className={classes.title}>{data.name || ''}</Typography>
            <div className={classes.card}>
               <div className={classes.cardAlignment}>
                  <img src={icon7} alt="icon" loading="lazy" className={classes.icon} />
                  <Typography className={classes.cardText}>
                     {/* {data && Array.isArray(data.jobType) && data.jobType.length > 0 && data.jobType[0].name ? data.jobType[0].name : ''} */}
                     {data && Array.isArray(data.jobRole) && data.jobRole.length > 0 && data.jobRole[0].name ? data.jobRole[0].name : ''}
                  </Typography>
               </div>
               <div className={classes.cardAlignment}>
                  <img src={icon8} alt="icon" loading="lazy" className={classes.icon} />
                  <Typography className={classes.cardText}>
                     {data && Array.isArray(data.locationType) && data.locationType.length > 0 && data.locationType[0].name ? data.locationType[0].name : ''}
                  </Typography>
               </div>
               <div className={classes.cardAlignment}>
                  <img src={icon9} alt="icon" loading="lazy" className={classes.icon} />
                  <Typography className={classes.cardText}>
                     {data && Array.isArray(data.industryType) && data.industryType.length > 0 && data.industryType[0].name ? data.industryType[0].name : ''}
                  </Typography>
               </div>
               {data && CheckValue(data.agencyLogo) && (
                  <div className={classes.cardAlignment}>
                     <div className={classes.companyLogoDiv}>
                        <img src={NodeURL + '/' + data.agencyLogo} alt="icon" loading="lazy" className={classes.companyLogo} />
                     </div>
                     <Typography className={classes.cardText}>{data && data.agencyName ? data.agencyName : ''}</Typography>
                  </div>
               )}
            </div>
            <div className={classes.salaryContainer}>
               <Typography className={classes.salaryText}>
                  <span>£{data.jobRate || ''}</span>/
                  {data && Array.isArray(data.jobSalaryInterval) && data.jobSalaryInterval.length > 0 && data.jobSalaryInterval[0].label
                     ? data.jobSalaryInterval[0].label
                     : ''}
               </Typography>
            </div>
            <div className={classes.applyButtonDiv}>
               <Button className={classes.applyButton} onClick={() => handleOnJobsRedirect(data)}>
                  Apply
               </Button>
            </div>
            <div className={classes.jobDescriptionDiv}>
               <Typography className={classes.jobDescriptionText}>
                  {data.jobDescription ? <div dangerouslySetInnerHTML={{ __html: data.jobDescription }} /> : ''}
               </Typography>
            </div>
            <div className={classes.footerBtnDiv}>
               <Button className={classes.backButton} onClick={handleOnJobView}>
                  Back to list
               </Button>
               <Button className={classes.applyButton} onClick={() => handleOnJobsRedirect(data)}>
                  Apply
               </Button>
            </div>
         </div>
         <Footer />
      </>
   )
}

export default ViewBrowseJobs
